export default {
  v3OfficialTopUpCenterTitle: '공식 사이트 충전 센터',
  v3OfficialTopUpCenterKeyword: '공식 사이트 충전 센터',
  v3OfficialTopUpCenterDescription: '공식 사이트 충전 센터',
  v3SafeAndFast: '안전하고 확실하게, 초고속 충전!',
  v3Shop: '상점',
  v3ShoppingCart: '장바구니',
  v3MembershipCenter: '혜택 센터(프리미엄 센터)',
  v3Login: '로그인',
  v3Account: '계정',
  v3EnterAccountName: '계정명을 입력하세요',
  v3Password: '비밀번호',
  v3EnterPassword: '비밀번호를 입력하세요',
  v3ForgotPassword: '비밀번호를 잊으셨나요?',
  v3EnterUID: 'UID를 입력하세요',
  v3OTP: 'OTP',
  v3EnterOTP: 'OTP를 입력하세요',
  v3SelectTopUpCharacter: '충전할 캐릭터를 선택하세요',
  v3SelectServer: '서버를 선택하세요',
  v3Confirm: '확인',
  v3CharacterNotFound:
    '캐릭터를 찾을 수 없는 경우, 먼저 게임 앱에서 캐릭터에 로그인한 다음 충전 페이지에 접속하거나 고객센터에 문의하세요.',
  v3Logout: '로그아웃',
  v3SwitchAccount: '계정 변경',
  v3MyCoupons: '내 쿠폰',
  v3BenefitsCenter: '프리미엄 센터',
  v3TopUpBenefits: '충전 혜택',
  v3MoreSettings: '설정 더 보기',
  v3RememberLoginStatus: '로그인 상태 기억하기',
  v3OrderQuery: '주문 조회',
  v3ContactCustomerService: '고객센터 연결',
  v3LoginWithApp: '앱으로 로그인',
  v3ChooseOtherLoginMethod: '다른 로그인 방식 선택',
  v3ConnectingToGameApp: '게임 앱에 연결 중',
  v3EnsureGameInstalled:
    '해당 기기에 게임이 설치되어 있는지 확인하세요. 게임이 응답하지 않거나 로그인에 실패할 경우, 앱스토어에서 게임을 최신 버전으로 업데이트하거나 다른 브라우저를 사용하세요.',
  v3OpenGame: '게임 실행',
  v3DownloadGame: '다운로드',
  v3UpdateGameIfOpenFails:
    '게임 실행에 실패할 경우, 앱스토어에서 최신 버전으로 업데이트하시기 바랍니다.',
  v3ClickToDownloadLatestVersion:
    '또는 게임 다운로드 버튼을 클릭하여 최신 버전을 다운로드할 수 있습니다.',
  v3LoggingIntoOfficialTopUpCenter: '[공식 사이트 충전 센터]에 접속 중입니다',
  v3CurrentAccount: '현재 계정: xxxxxxxxxx',
  v3WelcomeToOfficialTopUpCenter:
    '공식 사이트 충전 센터에 오신 것을 환영합니다',
  v3OfficialAuthorizedLogin: '공식 인증 로그인, 보안 위험 없음',
  v3TermsOfService: '서비스 약관',
  v3PrivacyPolicy: '개인정보 처리방침',
  v3ThirdPartySocialAccountDescription: '서드 파티 SNS 계정 안내',
  v3BindSocialAccountInGameFirst:
    '먼저 게임 내 유저 센터에서 SNS 계정 연동을 완료한 후, 연동된 SNS 계정으로 로그인하세요.',
  v3FirstTopUp15PercentOff: '첫 충전 시 최대 15% 할인',
  v3MoreTopUpRebates: '더 많은 충전 혜택이 계속해서 등장합니다',
  v3LoginToViewOffers: '접속해 혜택 확인하기',
  v3TopUpEnvironmentChecking: '충전 환경 확인 중...',
  v3SafeToUse: '안전하니 안심하고 사용하세요',
  v3LimitedTimeBenefits: '기간 한정 혜택',
  v3EventRules: '이벤트 규칙',
  v3MoreEvents: '이벤트 더 보기',
  v3Claim: '수령',
  v3Completed: '완료',
  v3GoTo: '이동',
  v3ViewDetails: '상세 보기',
  v3RecommendedProducts: '추천 상품',
  v3SearchProductName: '상품명 검색',
  v3AllCategories: '모든 카테고리',
  v3PopularSort: '인기순',
  v3PriceAscending: '가격 오름차순',
  v3PriceDescending: '가격 내림차순',
  v3DiamondBonus10Percent: '다이아 10% 추가',
  v3YuanbaoBonus10Percent: '원보 10% 추가',
  v3ExtraBonus10Percent: '10% 보너스',
  v3FirstTopUpDouble: '첫 충전 2배',
  v3FirstExtraBonus: '첫 보너스',
  v3ProductDetails: '상품 정보',
  v3AddToCart: '장바구니에 담기',
  v3AddedToCart: '장바구니에 추가되었습니다',
  v3BuyNow: '즉시 구매',
  v3NoItemsInCart: '장바구니에 상품이 없습니다',
  v3SelectedItemsN: '선택한 상품(${n})',
  v3RemoveFromCart: '장바구니에서 삭제하시겠습니까?',
  v3Yes: '네',
  v3No: '아니요',
  v3LimitOnePerPurchase: '해당 상품은 1회당 1개로 구매가 제한됩니다',
  v3ItemPrice: '상품 가격',
  v3Tax: '세금',
  v3ExtraGift: '보너스',
  v3Total: '합계',
  v3ProceedToPayment: '결제하기',
  v3SelectCoupon: '쿠폰 선택',
  v3UnavailableCoupons: '사용 불가능한 쿠폰',
  v3OneCouponPerOrder: '주문당 1장만 사용 가능',
  v3DiscountCoupon: '할인 쿠폰',
  v3ThresholdCoupon: '조건부 할인 쿠폰',
  v3MinSpendCoupon: 'xx USD 이상 구매 시 사용 가능',
  v3MaxDiscountCoupon: '최대 xxxx USD까지 할인',
  v3LimitedChannel: '지정된 채널에서만 사용 가능',
  v3AllChannels: '모든 채널에서 사용 가능',
  v3SpecificProducts: '지정 상품에만 사용 가능',
  v3AllProducts: '모든 상품에 사용 가능',
  v3NotYetTimeToUse: '사용 시간 미달',
  v3Expired: '기한 만료',
  v3Used: '사용 완료',
  v3ValidityPeriod: '유효기간: ',
  v3ConfirmUse: '사용 확인',
  v3ChangeProduct: '상품 변경',
  v3ConfirmPaymentOrder: '주문 결제 확인',
  v3StoredValueRole: '충전 캐릭터',
  v3TotalNProducts: '총 ${n}개 상품',
  v3SelectPaymentMethod: '결제 수단 선택',
  v3PayNow: '즉시 결제',
  v3MorePaymentMethods: '결제 수단 더 보기',
  v3NoAvailablePaymentMethodContactSupport:
    '사용 가능한 결제 수단을 찾을 수 없나요? 고객센터에 문의하세요.',
  v3AvailableCoupons: '사용 가능한 쿠폰',
  v3Extra10Percent: '10% 추가',
  v3LastSelection: '지난번 선택',
  v3RecommendedUsage: '추천 사용',
  v3PopularChoice: '인기 선택',
  v3PaymentSuccess: '결제 성공',
  v3PaymentFailure: '결제 실패',
  v3TopUpFailureMessage:
    '죄송합니다, 충전에 실패했습니다. 주문을 다시 시도하거나 아래 고객센터 버튼을 통해 문의해 주시기 바랍니다.',
  v3Game: '게임',
  v3UID: 'UID',
  v3OrderNumber: '주문 번호',
  v3ProductContent: '상품 내용',
  v3ViewProductDetails: '상품 정보 조회',
  v3PaymentMethod: '결제 수단',
  v3Complete: '완료',
  v3TopUpAgain: '추가 충전',
  v3FriendlyReminderSaveOrderInfo:
    'TIP: 주문 정보를 스크린샷으로 저장하시면 더 빠르게 처리해 드릴 수 있습니다',
  v3RechargeAgain: '재충전',
  v3TransactionInProgress: '거래 진행 중',
  v3CompletePaymentInChannel: '결제 채널로 이동하여 주문 결제를 완료해 주세요',
  v3RestAssuredFastDeliveryAfterPayment:
    '결제가 확인되는 즉시 아이템을 발송해 드리겠습니다',
  v3SaveOrderInfoForProgress:
    '거래 진행 상황을 확인할 수 있도록 주문 정보를 스크린샷으로 저장하시기 바랍니다',
  v3PaymentCompleted: '결제가 완료되었습니다',
  v3AddToHomeScreen: '홈 화면에 추가',
  v3AddShortcutForBonus: '바탕 화면에 바로가기를 추가하고 추가 보상을 받으세요',
  v3ShareSuccess: '공유 성공',
  v3ShareFailure: '공유 실패',
  v3RewardClaimed: '수령 성공',
  v3RewardClaimFailed: '수령 실패',
  v3EventNotStarted: '이벤트 준비 중',
  v3EventEnded: '이벤트가 종료되었습니다',
  v3ClickSelectCoupon: '쿠폰 선택 클릭',
  v3CouponsRecommendedUsed: '추천 쿠폰 사용됨',
  v3CouponsSelected: '선택된 쿠폰',
  v3NoCouponsAvaliable: '사용 가능한 쿠폰 없음',
  v3SupplementStatus: '상태',
  v3SupplementNormal: '정상',
  v3SupplementBanned: '차단됨',
  v3SupplementPendingPayment: '결제 대기 중',
  v3SupplementSwitchCharacter: '캐릭터 전환',
  v3SupplementAccountInfoInvalid: '계정 정보가 유효하지 않음',
  v3SupplementContactGSForTopUpLink: '충전 링크를 받으려면 GS에 문의하세요',
  v3SupplementTopUpCompleted: '충전 완료:',
  v3SupplementTotalRefundOrders: '총 {}건의 환불 주문',
  v3SupplementPendingSupplementAmount: '결제 대기 금액:',
  v3SupplementAccountCharacterNormalNoPaymentNeeded:
    '계정/캐릭터가 정상입니다. 결제가 필요하지 않습니다',
  v3SupplementEnjoyYourGame: '즐거운 게임 되세요!!',
  v3SupplementOrderInformation: '주문 정보',
  v3SupplementPendingPaymentAmount: '지불 대기 금액:',
  v3LookUpCouponRule: '쿠폰 지급 규정 조회',
  v3SwitchOldVersion: '결제 플랫폼 이전 버전으로 전환',
  v3FirstTopUpGiveaway: '첫 충전\n보너스',
  v3SecureConnection: '안전한 연결 중',
  v3RequestTimeOut: '로딩 시간 초과, 잠시 후 다시 시도해 주세요',
  v3ConfirmLeave: '정말 나가시겠습니까?',
  v3NoSubmitOrder:
    '장바구니에 담긴 상품을 결제하지 않으셨습니다. 나가시면 원하는 상품을 놓칠 수 있어요!',
  v3ContinueSubmit: '계속 쇼핑하기',
  v3LeaveSubmit: '나가기',
  v3RecentBug: '최근 구매',
  v3ScanCodeLogin: 'Scan Code Login',
  v3BindRole: 'Bind Role',
  v3ScanLoading: 'loading...',
  v3ScanExpired: 'QR code expired',
  v3ScanRefreshClick: 'Click to refresh',
  v3ScanRefreshTip: 'Please refresh and scan again',
  v3ScanRefresh: 'Refresh',
  v3ScanSucc: 'Scanned successfully',
  v3ScanAuth: 'Please confirm on your phone',
  v3ScanAuthSuccess: 'Authorization successful',
  v3ScanAuthSuccessTip: 'Logging in...',
  v3ScanUnauthorized: 'Authorization failed',
  v3ScanRefreshTip2: 'Log in to the game app to scan',
  v3ScanGuide: 'Scan Guide',
  v3ScanLoginError: 'Login error, please refresh and retry',
  v3ThirdPartyLogin: 'Third-party Login',
  v3NoMyLoginMethod: "Don't have my login method?",
  v3AccountPasswordLogin: 'Please enter account to bind game character',
  v3PwaTapShareOrMenuIcon: '브라우저 도구 모음에서 \'공유\' 또는 \'메뉴\' 아이콘을 클릭하세요',
  v3PwaFindAndTapAddToHomeScreen: '옵션에서 \'홈 화면에 추가\'를 찾아 클릭하세요',
  v3LaunchFromDesktopAndRewardToMailbox: '바탕화면에서 실행해 주세요\n캐릭터 선택 시 보상은 우편함으로 지급됩니다',
  v3ClaimSuccessCheckMailbox: '수령 성공\n게임 내 우편함을 확인해 주세요',
  v3ProductLimitOnceBadge: '1회 한정',
  v3ProductWeeklyOnlyBadge: '주간 한정',
  v3ProductMonthlyOnlyBadge: '월간 한정',
  v3ProductDiscountBadge: '**% 할인',
};
